import { render, staticRenderFns } from "./Salles.vue?vue&type=template&id=59abeecd&scoped=true"
import script from "./Salles.vue?vue&type=script&lang=js"
export * from "./Salles.vue?vue&type=script&lang=js"
import style0 from "./Salles.vue?vue&type=style&index=0&id=59abeecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59abeecd",
  null
  
)

export default component.exports